import React from 'react'
import { useMemo } from 'react'
import FollowUsSection from '../../sections/FollowUsSection'
import { socialIcons } from '../ContactSlice/consts'
import { FollowUsSliceProps } from './types'

const FollowUsSlice: React.FC<FollowUsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { fu_title, fu_is_main_heading } = primary || {}

  const data = useMemo(
    () =>
      items.map((item, index) => {
        const { fu_link, fu_icon } = item || {}

        return {
          key: index,
          label: fu_icon,
          icon: fu_icon && socialIcons[fu_icon],
          url: fu_link?.url || '#'
        }
      }),
    [items]
  )

  return (
    <FollowUsSection
      heading={fu_title?.text}
      isHeadingGreen
      isMainHeading={fu_is_main_heading}
      inner="inners.primary"
      paddingTop={['24px', '', '80px']}
      paddingBottom={['80px', '', '140px']}
      headingPadding={['38px', '', '87px']}
      bgColor="#F8FAFF"
      data={data}
    />
  )
}

export default FollowUsSlice
